import { render, staticRenderFns } from "./UpdatePriorityModal.vue?vue&type=template&id=41d3c535"
import script from "./UpdatePriorityModal.vue?vue&type=script&lang=js"
export * from "./UpdatePriorityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports